// src/services/feriadoService.js
import apiClient from './apiClient';

const feriadoService = {
    obtenerTodos: () =>
        apiClient.get('/datos-maestros/feriados'),

    // Los días inhábiles judiciales se mezclan en el backend (desde la tabla propia).
    // No se hace scraping inline aquí.
    obtenerActivos: () =>
        apiClient.get('/datos-maestros/feriados/activos'),

    obtenerActivosActualesYFuturos: () =>
        apiClient.get('/datos-maestros/feriados/activos/actuales-y-futuros'),

    obtenerPorAnio: (anio) =>
        apiClient.get(`/datos-maestros/feriados/anio/${anio}`),

    obtenerPorId: (id) =>
        apiClient.get(`/datos-maestros/feriados/${id}`),

    crear: (feriadoData) =>
        apiClient.post('/datos-maestros/feriados', feriadoData),

    crearMultiples: (feriadosData) =>
        apiClient.post('/datos-maestros/feriados/multiples', feriadosData),

    actualizar: (id, feriadoData) =>
        apiClient.put(`/datos-maestros/feriados/${id}`, feriadoData),

    eliminar: (id) =>
        apiClient.delete(`/datos-maestros/feriados/${id}`),

    eliminarPermanente: (id) =>
        apiClient.delete(`/datos-maestros/feriados/${id}/permanente`),

    esFeriado: (fecha) =>
        apiClient.get(`/datos-maestros/feriados/verificar/${fecha}`),

    calcularDiasHabiles: (fechaInicio, dias) =>
        apiClient.get('/datos-maestros/feriados/calcular-habiles', { params: { fechaInicio, dias } }),

    importarDesdeAPI: (anio) =>
        apiClient.post(`/datos-maestros/feriados/importar-desde-api/${anio}`),
};

export default feriadoService;
